export default "__VITE_ASSET__CIyafrc0__"